import React, {useRef, useState } from 'react'
import './registration.css'
import Header from '../home/header/Header'
import Menubar from '../home/menubar/Menubar'
import Address from '../home/footer/Address'
import ScrollToTopProgress from '../home/header/ScrollToTopProgress'
import { FaWindowClose } from "react-icons/fa";
import {registration} from "../home/data.js"

function Registration() {
    
      const {register_url} = registration
      //model
      const [loading, setLoading] = useState(false);
      const [modalMessage, setModalMessage] = useState('');
      const [showModal, setShowModal] = useState(false);
      //loading
    
      const formRef = useRef(null);
    
      const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);
      const isValidaltphone = (altphone) => /^[6-9]\d{9}$/.test(altphone);
    
      const userName = (event)=>{
            if(!/^[a-zA-Z ]$/.test(event.key) && event.key.length === 1){
              event.preventDefault();
            }
          }
      const emailValidation = (event)=>{
            if(!/^[a-zA-Z0-9@._-]$/.test(event.key) && event.key.length === 1){
              event.preventDefault();
            }
          }
      const numberValidation = (e) => {
            if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                  e.preventDefault();
                }
          }
      const handleReset = () => {
        setFormData({
          fname: '',
          lname: '',
          fathername:'',
          dob:'',
          doj:'',
          course:'',
          courseDuration:'',
          email: '',
          address: '',
          state: '',
          phone: '',
          altphone:'',
          gender:''
        });
        formRef.current.classList.remove('was-validated');
      };
      const [formData, setFormData] = useState({
         fname:'',
         lname:'',
         fathername:'',
         dob:'',
         doj:'',
         course:'',
         courseDuration:'',
         email:'',
         address:'',
         state:'',
         phone:'',
         altphone:'',
         gender:''
        });//
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        if ((name === 'phone' || name === 'altphone') && !/^\d*$/.test(value)) {
        return;
      }
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    
      const handleSubmit = async (event) => {  //async
        const form = formRef.current;
        event.preventDefault();
        // event.stopPropagation();
    
        if(!form.checkValidity()){
          form.classList.add('was-validated');
          return;
        }
        setLoading(true)
        try{
        // const res = await fetch("http://localhost:5000/send/register-now",{
        const res = await fetch("https://api-express-node-bd0o.onrender.com/send/register-now",{
          method:"POST",
          headers:{"Content-Type": "application/json"},
          body: JSON.stringify(formData),
        });
        const result = await res.json();
        setModalMessage(result.success? "Thanks for registering! We're excited to have you on board." : "Oops! Something went wrong. Please try again later.");
        setShowModal(true);
        handleReset();
      }
      catch(error){
        console.log("Error sending email:", error);
        // alert("Something went wrong. Please try again later.")
        setModalMessage("Something went wrong. Please try again later.");
        setShowModal(true);
      }
      finally{
        setLoading(false)
      }
      };
  return (
    <div>
        <Header/>
        <Menubar/>
        <div className="container">
          <div className='register-img'>
            <img src={register_url} style={{width: '100%'}} alt="Register" />
          </div>
                <section className='header-title'>
                    <div>
                        <h1>Registration Form</h1>
                        <h5 style={{borderBottomStyle: 'groove', top:'10px'}}>Empowering careers through practical IT education. Register now!</h5>
                    </div>
                </section>
            </div>

        <div className="container reg-container">
        <form
          className="row g-3 needs-validation"
          noValidate
          ref={formRef}
          onSubmit={handleSubmit}
        >
          <div className="col-md-4">
            <label htmlFor="validationCustom01" className="form-label">First Name</label>
            <input name='fname' type="text" className="form-control" id="validationCustom01" placeholder='Name' autoComplete='off' required 
            onKeyDown={userName} onChange={handleChange} maxLength={50} value={formData.fname}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom02" className="form-label">Last Name</label>
            <input type="text" name='lname' className="form-control" id="validationCustom02" placeholder='Surname' autoComplete='off' required 
            onKeyDown={userName} onChange={handleChange} maxLength={50} value={formData.lname}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom03" className="form-label">Father Name</label>
            <input type="text" name='fathername' className="form-control" id="validationCustom03" placeholder='Father name' autoComplete='off' required 
            onKeyDown={userName} onChange={handleChange} maxLength={50} value={formData.fathername}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom04" className="form-label">Date of Birth</label>
            <input type="date" name='dob' className="form-control" id="validationCustom04" autoComplete='off' required 
            onChange={handleChange} value={formData.dob}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>
         

          <div className="col-md-4">
            <label htmlFor="validationCustom05" className="form-label">Course</label>
            <select className="form-select" id="validationCustom05" required name='course' value={formData.course} onChange={handleChange}>
              <option value="">Select</option>
              <option value="Ms_Office">Ms Office</option>
              <option value="DTP">DTP</option>
              <option value="C_Language">C-Language</option>
              <option value="Video_Editing">Video Editing</option>
              <option value="Tally">Tally</option>
              <option value="Html">HTML</option>
            </select>
            <div className="invalid-feedback">Please select any course.</div>
          </div>
          
          <div className="col-md-4">
            <label htmlFor="validationCustom06" className="form-label">Course Duration</label>
            <input type="text" name='courseDuration' className="form-control" id="validationCustom06" placeholder='Course Duration' autoComplete='off' required 
            onChange={handleChange} maxLength={15} value={formData.courseDuration}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom11" className="form-label">Date of Join</label>
            <input type="date" name='doj' className="form-control" id="validationCustom11" autoComplete='off' required 
            onChange={handleChange} value={formData.doj}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>
          
          <div className="col-md-4">
            <label htmlFor="validationCustom07" className="form-label">Address</label>
            <input type="text" className="form-control" id="validationCustom07" autoComplete='off' required maxLength={50} name='address' value={formData.address} onChange={handleChange}/>
            <div className="invalid-feedback">Please provide a valid Address.</div>
          </div>
          
          <div className="col-md-4">
            <label htmlFor="validationCustom08" className="form-label">State</label>
            <select className="form-select" id="validationCustom08" required name='state' value={formData.state} onChange={handleChange}>
              <option value="">Select</option>
              <option value="AP">Andhra Pradesh</option>
              <option value="TS">Telangana</option>
            </select>
            <div className="invalid-feedback">Please select a valid state.</div>
          </div>
          
          <div className="col-md-4">
            <label htmlFor="validationCustom09" className="form-label">Contact No</label>
            <input
              name='phone'
              type="text"
              inputMode="numeric"
              maxLength={10}
              minLength={10}
              className={`form-control ${formData.phone && !isValidPhone(formData.phone) ? 'is-invalid' : ''}`}
              id="validationCustom09 phone"
              required
              value={formData.phone}
              onChange={handleChange}
              onKeyDown={numberValidation}
              autoComplete='off'
            />

            <div className="invalid-feedback">Please provide a valid phone no.</div>
          </div>

          
          <div className="col-md-4">
            <label htmlFor="validationCustom10" className="form-label">Alternate Contact No</label>
            <input
              name='altphone'
              type="text"
              inputMode="numeric"
              maxLength={10}
              minLength={10}
              className={`form-control ${formData.altphone && !isValidaltphone(formData.altphone) ? 'is-invalid' : ''}`}
              id="validationCustom10 altphone"
              value={formData.altphone}
              onChange={handleChange}
              onKeyDown={numberValidation}
              autoComplete='off'
            />

            <div className="invalid-feedback">Please provide a valid phone no.</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationemail" className="form-label">Email Id</label>
            <div className="input-group has-validation">
              <span className="input-group-text" id="inputGroupPrepend">@</span>
              <input
                type="email"
                className="form-control"
                id="validationemail"
                aria-describedby="inputGroupPrepend"
				        autoComplete='off'
                onKeyDown={emailValidation}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <div className="invalid-feedback">Please provide a valid Mail.</div>
            </div>
          </div>

        <div className='col-md-4 radio-btns'>
        <div className="col-md-2 form-check form-check-inline">
            <input className="form-check-input" type="radio" name="gender" value='Male' checked={formData.gender === 'Male'}
            onChange={handleChange} id="inlineRadio1"/>
                <label className="form-check-label" htmlFor="inlineRadio1">
                Male
                </label>
        </div>
        <div className=" col-md-2 form-check form-check-inline">
            <input className="form-check-input" type="radio" name="gender" value='Female' checked={formData.gender === 'Female'}
            onChange={handleChange} id="inlineRadio2" required/>
                <label className="form-check-label" htmlFor="inlineRadio2">
                Female
                </label>
        {/* <div className="invalid-feedback">Please select a gender.</div> */}
        </div>
        </div>
        

          <div className="col-12 reg-btns">
            <button className="btn btn-primary" type="submit">Register</button>&emsp;&emsp;
            <button className="btn btn-danger" type="reset"  onClick={handleReset}>Reset</button>
          </div>
        </form>
      </div>
        <Address/>
        <ScrollToTopProgress/>

           
        {/* Loading Spinner */}
        {loading && (
          <div className="loading-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        
        {/* Modal Popup */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div><button className='close-btn' onClick={() => setShowModal(false)}><FaWindowClose/></button></div>
              <p className='modal-msg'>{modalMessage}</p>
              <button className="btn btn-primary" onClick={() => setShowModal(false)}>Close</button>
            </div>
          </div>
        )}

    </div>
  )
}

export default Registration